import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { RecentClimateService } from '../services/RecentClimateService';

export class RecentClimateLayer extends BaseProduct {
  public readonly id: ProductId = 'recent_climate';
  private unsubscribeStore: (() => void) | null = null;
  private lastKey: string = '';

  protected onActivate(): void {
    this.lastKey = '';
    this.refresh();
    this.unsubscribeStore = store.subscribe((s) => {
      if (!this.active) return;
      const sel = RecentClimateService.resolveSelection(
        s.manifest,
        s.recentClimateYear,
        s.recentClimateTimeMode,
        s.recentClimateMonth,
        s.recentClimateVariable
      );
      const opacity = getLayerOpacity(this.id, 0.85);
      const nextKey = `${sel.year}_${sel.periodTag}_${sel.variable}_${sel.yearMeta.version}_${opacity.toFixed(2)}`;
      if (nextKey !== this.lastKey) {
        this.refresh();
      }
    });
  }

  protected onDeactivate(): void {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.layerManager.removeLayer(this.id);
    this.lastKey = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    if (this.active) {
      this.refresh();
    }
  }

  public refresh(): void {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const sel = RecentClimateService.resolveSelection(
      manifest,
      state.recentClimateYear,
      state.recentClimateTimeMode,
      state.recentClimateMonth,
      state.recentClimateVariable
    );
    const opacity = getLayerOpacity(this.id, 0.85);
    this.lastKey = `${sel.year}_${sel.periodTag}_${sel.variable}_${sel.yearMeta.version}_${opacity.toFixed(2)}`;

    const tileUrl = RecentClimateService.getPmtilesUrl(
      manifest,
      sel.year,
      sel.periodTag,
      sel.variable
    );
    if (!tileUrl) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
      return;
    }

    const maxZoom = sel.variable === 'snow' ? 6 : 5;
    this.layerManager.updateBufferedRasterLayer(this.id, [tileUrl], opacity, undefined, 0, maxZoom);
  }
}

export default RecentClimateLayer;
